module.exports = __webpack_public_path__ + "img/powerGrid-icon_2.3ac7cba6.png";